/**
 * Иконки прототипа админки (03_dorixona_monorepo/docs/ui/admin.html) одним
 * спрайтом. Спрайт рисуется один раз в каркасе, дальше иконка берётся по
 * имени: <Icon name="i-dash" />. Цвет наследуется через currentColor.
 */
export const ICON_NAMES = [
  'i-dash',
  'i-pill',
  'i-tag',
  'i-box',
  'i-users',
  'i-pin',
  'i-locate',
  'i-badge',
  'i-key',
  'i-gear',
  'i-search',
  'i-plus',
  'i-edit',
  'i-trash',
  'i-eye',
  'i-x',
  'i-sync',
  'i-burger',
  'i-coins',
  'i-flow',
  'i-back',
  'i-plug',
  'i-img',
  'i-card',
  'i-chart',
  'i-clock',
  'i-phone',
  'i-copy',
  'i-down',
  'i-check',
  'i-note',
  'i-truck',
  'i-exit',
  'i-layers',
  'i-stories',
  'i-news',
  'i-star',
  'i-star-fill',
  'i-alert',
  'i-info',
  'i-sort',
  'i-arrow-up',
  'i-arrow-down',
  'i-grip',
  'i-calendar',
  'i-chevron-left',
  'i-chevron-right',
  'i-bell',
] as const

export type IconName = (typeof ICON_NAMES)[number]

export function IconSprite() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <symbol id="i-dash" viewBox="0 0 24 24">
        <rect
          x="4"
          y="4"
          width="7"
          height="9"
          rx="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <rect
          x="13"
          y="4"
          width="7"
          height="5"
          rx="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <rect
          x="13"
          y="11"
          width="7"
          height="9"
          rx="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <rect
          x="4"
          y="15"
          width="7"
          height="5"
          rx="2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
      </symbol>
      <symbol id="i-pill" viewBox="0 0 24 24">
        <rect
          x="3.2"
          y="9"
          width="17.6"
          height="9"
          rx="4.5"
          transform="rotate(-38 12 13)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <path d="m8.6 9.2 5.4 6.8" stroke="currentColor" strokeWidth="1.9" />
      </symbol>
      <symbol id="i-tag" viewBox="0 0 24 24">
        <path
          d="M4 5.5A1.5 1.5 0 0 1 5.5 4h5.6a2 2 0 0 1 1.4.6l7 7a1.9 1.9 0 0 1 0 2.7l-5.2 5.2a1.9 1.9 0 0 1-2.7 0l-7-7a2 2 0 0 1-.6-1.4z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
        <circle cx="9" cy="9" r="1.4" fill="currentColor" />
      </symbol>
      <symbol id="i-box" viewBox="0 0 24 24">
        <path
          d="m12 3 8 4.5v9L12 21l-8-4.5v-9z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
        <path
          d="m4 7.5 8 4.5 8-4.5M12 12v9"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-users" viewBox="0 0 24 24">
        <circle cx="9" cy="8.5" r="3.4" fill="none" stroke="currentColor" strokeWidth="1.9" />
        <path
          d="M3 19.5a6 6 0 0 1 12 0M15.5 5.6a3.4 3.4 0 0 1 0 5.8M17.5 13.6a6 6 0 0 1 3.5 5.9"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-pin" viewBox="0 0 24 24">
        <path
          d="M12 21s-7-6.1-7-11a7 7 0 0 1 14 0c0 4.9-7 11-7 11z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <circle cx="12" cy="10" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.9" />
      </symbol>
      <symbol id="i-locate" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.9" />
        <circle cx="12" cy="12" r="2.2" fill="currentColor" />
        <path
          d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-badge" viewBox="0 0 24 24">
        <rect
          x="3.5"
          y="5"
          width="17"
          height="14"
          rx="2.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <circle cx="9" cy="11" r="2" fill="none" stroke="currentColor" strokeWidth="1.7" />
        <path
          d="M6 16.5a3.2 3.2 0 0 1 6 0M14.5 9.5H18M14.5 13H18"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-key" viewBox="0 0 24 24">
        <circle cx="8" cy="8.5" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.9" />
        <path
          d="m11.2 11.7 8.3 8.3M15 15.5l2.4-2.4M18 18.5l2-2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-gear" viewBox="0 0 24 24">
        {/* Шестерёнка с зубцами: круг с лучами читался как солнце. */}
        <path
          d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.9" />
      </symbol>
      <symbol id="i-search" viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="m16.5 16.5 4.5 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </symbol>
      <symbol id="i-plus" viewBox="0 0 24 24">
        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </symbol>
      <symbol id="i-edit" viewBox="0 0 24 24">
        <path
          d="M4 20h4.5L20 8.5a2.1 2.1 0 0 0-3-3L5.5 17z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
        <path d="m14.5 8 3 3" stroke="currentColor" strokeWidth="1.9" />
      </symbol>
      <symbol id="i-trash" viewBox="0 0 24 24">
        <path
          d="M5 7h14M10 7V5h4v2M7 7l1 13h8l1-13M10 11v6M14 11v6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-eye" viewBox="0 0 24 24">
        <path
          d="M3 12s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="2.6" fill="none" stroke="currentColor" strokeWidth="1.9" />
      </symbol>
      <symbol id="i-x" viewBox="0 0 24 24">
        <path
          d="m6 6 12 12M18 6 6 18"
          stroke="currentColor"
          strokeWidth="2.1"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-sync" viewBox="0 0 24 24">
        <path
          d="M4.5 12a7.5 7.5 0 0 1 13-5.2M19.5 12a7.5 7.5 0 0 1-13 5.2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
        <path
          d="M17.5 3v4h-4M6.5 21v-4h4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-burger" viewBox="0 0 24 24">
        <path
          d="M4 7h16M4 12h16M4 17h16"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-coins" viewBox="0 0 24 24">
        <ellipse
          cx="12"
          cy="6.5"
          rx="7"
          ry="3"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <path
          d="M5 6.5v5c0 1.7 3.1 3 7 3s7-1.3 7-3v-5M5 11.5v5c0 1.7 3.1 3 7 3s7-1.3 7-3v-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
      </symbol>
      <symbol id="i-flow" viewBox="0 0 24 24">
        <rect
          x="3.5"
          y="4"
          width="5"
          height="16"
          rx="1.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <rect
          x="9.5"
          y="4"
          width="5"
          height="10"
          rx="1.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <rect
          x="15.5"
          y="4"
          width="5"
          height="13"
          rx="1.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
      </symbol>
      <symbol id="i-back" viewBox="0 0 24 24">
        <path
          d="M15 5l-7 7 7 7"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-plug" viewBox="0 0 24 24">
        {/* Интеграции — деталь пазла: вилка со штырями читалась как «ψ». */}
        <path
          d="M15.39 4.39a1 1 0 0 0 1.68-.47 2.5 2.5 0 1 1 3.01 3.01 1 1 0 0 0-.47 1.68l1.68 1.68a2.41 2.41 0 0 1 0 3.42l-1.68 1.68a1 1 0 0 1-1.68-.47 2.5 2.5 0 1 0-3.01 3.01 1 1 0 0 1 .47 1.68l-1.68 1.68a2.41 2.41 0 0 1-3.42 0l-1.68-1.68a1 1 0 0 0-1.68.47 2.5 2.5 0 1 1-3.01-3.01 1 1 0 0 0 .47-1.68l-1.68-1.68a2.41 2.41 0 0 1 0-3.42l1.68-1.68a1 1 0 0 1 1.68.47 2.5 2.5 0 1 0 3.01-3.01 1 1 0 0 1-.47-1.68l1.68-1.68a2.41 2.41 0 0 1 3.42 0z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-img" viewBox="0 0 24 24">
        <rect
          x="3.5"
          y="5"
          width="17"
          height="14"
          rx="2.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <circle cx="9" cy="10" r="1.7" fill="none" stroke="currentColor" strokeWidth="1.7" />
        <path
          d="m4.5 17 4.5-4.5 3.5 3.5 3-2.5 4 3.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-card" viewBox="0 0 24 24">
        <rect
          x="2.8"
          y="5"
          width="18.4"
          height="14"
          rx="2.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <path
          d="M2.8 9.8h18.4M6 15h4"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-chart" viewBox="0 0 24 24">
        <path
          d="M4 20V10M10 20V4M16 20v-7M22 20H2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-calendar" viewBox="0 0 24 24">
        <rect
          x="3.5"
          y="5"
          width="17"
          height="15.5"
          rx="2.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
        />
        <path
          d="M3.5 10h17M8 3v4M16 3v4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-chevron-left" viewBox="0 0 24 24">
        <path
          d="m14.5 6-6 6 6 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-chevron-right" viewBox="0 0 24 24">
        <path
          d="m9.5 6 6 6-6 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-clock" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.9" />
        <path
          d="M12 7.5V12l3 2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-phone" viewBox="0 0 24 24">
        <path
          d="M6.5 3.5h3l1.5 4-2 1.5a12 12 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16.8 16.8 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-copy" viewBox="0 0 24 24">
        <rect
          x="9"
          y="9"
          width="11"
          height="11"
          rx="2.2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M15 6.5V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
      </symbol>
      <symbol id="i-down" viewBox="0 0 24 24">
        <path
          d="M12 4v12M7 11.5l5 5 5-5M4 20h16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-check" viewBox="0 0 24 24">
        <path
          d="m5 12.5 4.5 4.5L19 7"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-note" viewBox="0 0 24 24">
        <path
          d="M5.5 3.5h13a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M8 8h8M8 12h8M8 16h5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-truck" viewBox="0 0 24 24">
        <path
          d="M2.5 6.5h10.5v9.5H2.5zM13 9.5h4l3.5 3.2V16H13z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <circle cx="7" cy="18" r="1.9" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17" cy="18" r="1.9" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </symbol>
      <symbol id="i-exit" viewBox="0 0 24 24">
        <path
          d="M14 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H14"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
        />
        <path
          d="M17 8.5 20.5 12 17 15.5M20 12H10"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-layers" viewBox="0 0 24 24">
        <path
          d="m12 3 9 4.5-9 4.5-9-4.5z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="m3.5 12 8.5 4.3 8.5-4.3M3.5 16.6 12 21l8.5-4.4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-stories" viewBox="0 0 24 24">
        <circle
          cx="12"
          cy="12"
          r="8.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeDasharray="10 3.4"
          strokeLinecap="round"
        />
        <path d="M10.3 9.2v5.6l4.6-2.8z" fill="currentColor" />
      </symbol>
      <symbol id="i-news" viewBox="0 0 24 24">
        <path
          d="M5 4.5h11a1.5 1.5 0 0 1 1.5 1.5v12.5a1.5 1.5 0 0 0 1.5 1.5H6.5A2.5 2.5 0 0 1 4 17.5V5.5a1 1 0 0 1 1-1z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 9H20v9.5a1.5 1.5 0 0 1-3 0M7.5 8.5h6M7.5 12h6M7.5 15.5h4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-star" viewBox="0 0 24 24">
        <path
          d="m12 3.6 2.6 5.3 5.8.8-4.2 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.2-4.1 5.8-.8z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-star-fill" viewBox="0 0 24 24">
        <path
          d="m12 3.6 2.6 5.3 5.8.8-4.2 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.2-4.1 5.8-.8z"
          fill="currentColor"
        />
      </symbol>
      <symbol id="i-alert" viewBox="0 0 24 24">
        <path
          d="M12 3.8 2.8 19.5a1 1 0 0 0 .9 1.5h16.6a1 1 0 0 0 .9-1.5L12 3.8z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinejoin="round"
        />
        <path
          d="M12 10v4.5M12 17.5v.01"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-info" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.9" />
        <path
          d="M12 11v5.5M12 7.5v.01"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </symbol>
      <symbol id="i-sort" viewBox="0 0 24 24">
        <path
          d="M7 4v16M7 20l-3-3M7 20l3-3M17 20V4M17 4l-3 3M17 4l3 3"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-arrow-up" viewBox="0 0 24 24">
        <path
          d="M12 19V5M6 11l6-6 6 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-arrow-down" viewBox="0 0 24 24">
        <path
          d="M12 5v14M6 13l6 6 6-6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="i-grip" viewBox="0 0 24 24">
        <g fill="currentColor">
          <circle cx="9" cy="6" r="1.6" />
          <circle cx="15" cy="6" r="1.6" />
          <circle cx="9" cy="12" r="1.6" />
          <circle cx="15" cy="12" r="1.6" />
          <circle cx="9" cy="18" r="1.6" />
          <circle cx="15" cy="18" r="1.6" />
        </g>
      </symbol>
      <symbol id="i-bell" viewBox="0 0 24 24">
        <path
          d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2H4.5zM10 20.5a2 2 0 0 0 4 0"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
    </svg>
  )
}

export interface IconProps {
  name: IconName
  size?: number
  className?: string
}

export function Icon({ name, size = 20, className }: IconProps) {
  return (
    <svg width={size} height={size} className={className} aria-hidden="true">
      <use href={`#${name}`} />
    </svg>
  )
}
